import { Dialog as MuiDialog, DialogProps } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

interface Props extends DialogProps {
  className?: string;
}

const WizardDialogImpl: React.FC<Props> = ({
  className,
  open,
  scroll,
  children,
}) => {
  return (
    <div className={className}>
      <MuiDialog fullScreen open={open} scroll={scroll ?? 'paper'}>
        {children}
      </MuiDialog>
    </div>
  );
};

/**
 * A convenience wrapper around `<Dialog/>` that sets the dialog to be full screen
 * and sets the scroll behavior to `paper`.
 *
 * This is meant to be used for multi-step wizard type flows.
 * For example, project creation flow.
 */
export const WizardDialog = muiStyled(WizardDialogImpl)(({ theme }) => css``);
